(function(){function Oe(e,t=document){return t.querySelector(e)}function V(e,t,r,i){const a=r;return e.addEventListener(t,a,i),()=>e.removeEventListener(t,a,i)}function Ne(e,t){let r=null,i=null;const a=()=>{r=null;const h=i;i=null,h&&e(...h)},f=((...h)=>{i=h,r!==null&&clearTimeout(r),r=setTimeout(a,t)});return f.cancel=()=>{r!==null&&(clearTimeout(r),r=null),i=null},f.flush=()=>{r!==null&&(clearTimeout(r),a())},f}var Re=class extends Error{constructor(e,t){super(e),this.name="CartError",this.status=t}},He=150,ye="youngle:cart:changed",_e={},oe=null,pe=He,se,re=new Set,j=null,J=null,ee=null,G=null;function Be(){var e;if(se!==void 0&&se.length>0)return se;const t=typeof window!="undefined"?(e=window.Shopify)===null||e===void 0||(e=e.routes)===null||e===void 0?void 0:e.root:void 0;return t!==void 0&&t.length>0?t:"/"}function ke(e){const t=Be();return`${t.endsWith("/")?t:`${t}/`}${e.startsWith("/")?e.slice(1):e}`}async function we(e,t){if(!e.ok)throw new Re(`Cart request to ${t} failed with status ${e.status}`,e.status);return await e.json()}function qe(){return G||(G=Ne(()=>{for(const t of re)t()},pe)),G}function Ee(){const e=qe();oe!==null&&j===null&&typeof MutationObserver!="undefined"&&(j=new MutationObserver(()=>e()),j.observe(oe,{childList:!0,subtree:!0})),J===null&&typeof document!="undefined"&&(J=()=>{document.visibilityState==="visible"&&e()},document.addEventListener("visibilitychange",J)),ee===null&&typeof document!="undefined"&&(ee=t=>{const r=t.detail;r!=null&&r.sender===_e||e()},document.addEventListener(ye,ee))}function Ue(){j!==null&&(j.disconnect(),j=null),J!==null&&typeof document!="undefined"&&(document.removeEventListener("visibilitychange",J),J=null),ee!==null&&typeof document!="undefined"&&(document.removeEventListener(ye,ee),ee=null),G!==null&&(G.cancel(),G=null)}function Fe(e){const t=Object.prototype.hasOwnProperty.call(e,"container"),r=t&&e.container!==oe,i=e.debounceMs!==void 0&&e.debounceMs!==pe;if(t){var a;oe=(a=e.container)!==null&&a!==void 0?a:null}e.debounceMs!==void 0&&(pe=e.debounceMs),e.routeRoot!==void 0&&(se=e.routeRoot),r&&j!==null&&(j.disconnect(),j=null),i&&G!==null&&(G.cancel(),G=null),re.size>0&&Ee()}async function ze(e,t){const r=await we(await fetch(ke("/cart/change.js"),{method:"POST",credentials:"same-origin",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({id:e,quantity:t})}),"/cart/change.js");return Ce(),r}async function je(){return we(await fetch(ke("/cart.js"),{method:"GET",credentials:"same-origin",headers:{Accept:"application/json"}}),"/cart.js")}function Ge(e){return re.add(e),Ee(),()=>{re.delete(e),re.size===0&&Ue()}}function Ce(){qe()(),typeof document!="undefined"&&document.dispatchEvent(new CustomEvent(ye,{detail:{sender:_e}}))}var xe="youngle:quiz-result";function Ye(e){const t=i=>{e(i.detail)};document.addEventListener(xe,t);const r=window.YoungleQuizResult;return r!==void 0&&e(r),()=>{document.removeEventListener(xe,t)}}var Ve="_youngle_quiz",Ke="1",le=null;function Ae(e){var t;return e.includes("&")?((t=le)!==null&&t!==void 0||(le=document.createElement("textarea")),le.innerHTML=e,le.value):e}var Te=Object.freeze({items:[],itemCount:0,totalCents:0,totalSavingsCents:0,hasSubscriptionItems:!1,discountCodeTotalCents:0,recurringTotalCents:0});function We(e,t){if(e.itemCount!==t.itemCount||e.totalCents!==t.totalCents||e.totalSavingsCents!==t.totalSavingsCents||e.hasSubscriptionItems!==t.hasSubscriptionItems||e.discountCodeTotalCents!==t.discountCodeTotalCents||e.recurringTotalCents!==t.recurringTotalCents||e.items.length!==t.items.length)return!1;for(let r=0;r<e.items.length;r++){const i=e.items[r],a=t.items[r];if(i.variantId!==a.variantId||i.lineKey!==a.lineKey||i.quantity!==a.quantity||i.priceCents!==a.priceCents||i.originalLinePriceCents!==a.originalLinePriceCents||i.isSubscription!==a.isSubscription||i.sellingPlanName!==a.sellingPlanName||i.productTitle!==a.productTitle||i.imageUrl!==a.imageUrl)return!1}return!0}function Qe(e){let t={...Te,items:[]},r=!1,i=null;const a=new Set;let f=!1;function h(){for(const g of a)g(t)}async function p(){let g;try{g=await je()}catch{f||(console.warn("routine-cart-tracker: getCart() failed; retaining previous state"),f=!0);return}f=!1;const l=[];let _=0,v=0,b=0,E=0,w=0,L=!1;for(const k of g.items){var I,A,P,C;const T=k.properties;if((T==null?void 0:T[Ve])!==Ke)continue;const o=k.variant_id,Y=k.key,N=k.quantity,$=k.final_line_price,u=typeof k.original_line_price=="number"?k.original_line_price:$,d=k.selling_plan_allocation,y=d!=null,B=y&&typeof(d==null||(I=d.selling_plan)===null||I===void 0?void 0:I.name)=="string"?d.selling_plan.name:null,S=e.lookupByVariant(o);let D=u;if(y&&typeof(d==null?void 0:d.compare_at_price)=="number"&&d.compare_at_price>0){const z=d.compare_at_price*N;z>D&&(D=z)}if(D<=$&&S!==null){const z=S.compareAtPrice*N;z>$&&(D=z)}let M=Ae((A=k.title)!==null&&A!==void 0?A:"");const K=Ae((P=k.variant_title)!==null&&P!==void 0?P:"")||null;let U=(C=k.image)!==null&&C!==void 0?C:null;(!M||U===null)&&S!==null&&(M||(M=S.handle),U===null&&(U=S.url));let F=u;y&&typeof(d==null?void 0:d.price)=="number"&&d.price>0&&(F=d.price*N);const Q=Math.max(0,F-$);l.push({variantId:o,lineKey:Y,productTitle:M,variantTitle:K,quantity:N,priceCents:$,originalLinePriceCents:D,isSubscription:y,sellingPlanName:B,imageUrl:U,discountCodeCents:Q}),_+=$,E+=F,w+=N,b+=Q;const X=D-$;X>0&&(v+=X),y&&(L=!0)}const H={items:l,itemCount:w,totalCents:_,totalSavingsCents:v,hasSubscriptionItems:L,discountCodeTotalCents:b,recurringTotalCents:E};r=!0,!We(t,H)&&(t=H,h())}function s(){return i!==null&&(i(),i=null),i=Ge(()=>{p()}),p(),()=>{i!==null&&(i(),i=null),t={...Te,items:[]},r=!1,f=!1}}function q(g){return a.add(g),r&&g(t),()=>{a.delete(g)}}function x(){return t}return{start:s,onChange:q,getState:x}}function Xe(e){var t;const r=typeof window!="undefined"?(t=window.Shopify)===null||t===void 0||(t=t.routes)===null||t===void 0?void 0:t.root:void 0,i=r!==void 0&&r.length>0?r:"/";return`${i.endsWith("/")?i:`${i}/`}${e.startsWith("/")?e.slice(1):e}`}var Ze="gid://shopify/Product/";function Je(e){return e.startsWith(Ze)?e.slice(22):e}function Le(e){return`yqr-spotlight-${Je(e)}`}var et=class extends Error{constructor(e){super(e),this.name="StickyBarConfigError"}},tt="Your Routine",rt="Go to checkout",nt="View recommendation",it="Your routine is waiting",at="Your #1 is waiting: {name}",ot="Next up: {name}",st="Back to top",lt="Back to top",ct="Continue exploring",dt="View routine",ut="{count} items",yt="{count} item",pt="You save {{amount}}",bt="{{amount}} recurring",ft="{{amount}} first order only",mt="then {{amount}}/delivery ({{percent}}% lifetime savings)",gt="Remove",vt="",ht=64;function _t(e){var t,r,i,a,f,h,p,s,q,x,g,l,_,v,b,E,w,L;const I=((t=e.getAttribute("data-yqr-sticky-bar-heading"))===null||t===void 0?void 0:t.trim())||tt,A=((r=e.getAttribute("data-yqr-sticky-bar-checkout-label"))===null||r===void 0?void 0:r.trim())||rt,P=((i=e.getAttribute("data-yqr-sticky-bar-empty-cta-label"))===null||i===void 0?void 0:i.trim())||nt,C=((a=e.getAttribute("data-yqr-sticky-bar-empty-heading-label"))===null||a===void 0?void 0:a.trim())||it,H=((f=e.getAttribute("data-yqr-sticky-bar-empty-heading-primary-template"))===null||f===void 0?void 0:f.trim())||at,k=((h=e.getAttribute("data-yqr-sticky-bar-empty-heading-secondary-template"))===null||h===void 0?void 0:h.trim())||ot,T=((p=e.getAttribute("data-yqr-sticky-bar-empty-heading-top-label"))===null||p===void 0?void 0:p.trim())||st,o=((s=e.getAttribute("data-yqr-sticky-bar-empty-cta-top-label"))===null||s===void 0?void 0:s.trim())||lt,Y=((q=e.getAttribute("data-yqr-sticky-bar-continue-label"))===null||q===void 0?void 0:q.trim())||ct,N=((x=e.getAttribute("data-yqr-sticky-bar-view-routine-label"))===null||x===void 0?void 0:x.trim())||dt,$=((g=e.getAttribute("data-yqr-sticky-bar-item-count-template"))===null||g===void 0?void 0:g.trim())||ut,u=((l=e.getAttribute("data-yqr-sticky-bar-item-count-one-template"))===null||l===void 0?void 0:l.trim())||yt,d=((_=e.getAttribute("data-yqr-sticky-bar-you-save-template"))===null||_===void 0?void 0:_.trim())||pt,y=((v=e.getAttribute("data-yqr-sticky-bar-savings-recurring-template"))===null||v===void 0?void 0:v.trim())||bt,B=((b=e.getAttribute("data-yqr-sticky-bar-savings-first-order-template"))===null||b===void 0?void 0:b.trim())||ft,S=((E=e.getAttribute("data-yqr-sticky-bar-then-recurring-template"))===null||E===void 0?void 0:E.trim())||mt,D=((w=e.getAttribute("data-yqr-sticky-bar-remove-label"))===null||w===void 0?void 0:w.trim())||gt,M=((L=e.getAttribute("data-yqr-sticky-bar-bundle-upsell"))===null||L===void 0?void 0:L.trim())||vt,K=e.getAttribute("data-yqr-sticky-bar-padding-compensation"),U=K!==null?parseInt(K,10):NaN;return{heading:I,checkoutLabel:A,emptyCtaLabel:P,emptyHeadingLabel:C,emptyHeadingPrimaryTemplate:H,emptyHeadingSecondaryTemplate:k,emptyHeadingTopLabel:T,emptyCtaTopLabel:o,continueLabel:Y,viewRoutineLabel:N,itemCountTemplate:$,itemCountOneTemplate:u,youSaveTemplate:d,savingsRecurringTemplate:y,savingsFirstOrderTemplate:B,thenRecurringTemplate:S,removeLabel:D,bundleUpsellMessage:M,paddingBottomCompensation:Number.isFinite(U)?U:ht}}function be(e,t){var r;if(typeof window=="undefined")return;const i=(r=window.Shopify)===null||r===void 0?void 0:r.analytics;if(!(i===void 0||typeof i.publish!="function"))try{i.publish(e,t)}catch{}}var fe="data-html-placeholder";function Se(e){return e.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;")}function kt(e){return typeof e=="object"&&e!==null&&"raw"in e&&typeof e.raw=="string"}function wt(e){if(e==null||e===!1)return"";if(e===!0)return"true";if(typeof e=="string")return Se(e);if(typeof e=="number")return Se(String(e));if(kt(e))return e.raw;if(e instanceof Node)return e;if(Array.isArray(e)){if(e.every(t=>t instanceof Node)){const t=document.createDocumentFragment();for(const r of e)t.appendChild(r);return t}throw new TypeError("html: arrays of non-Node values are not supported")}throw typeof e=="function"?new TypeError("html: functions are not supported as interpolated values"):new TypeError(`html: unsupported interpolated value of type ${typeof e}`)}function O(e,...t){const r=new Map;let i="";for(let p=0;p<e.length;p++){var a;if(i+=(a=e[p])!==null&&a!==void 0?a:"",p<t.length){const s=wt(t[p]);typeof s=="string"?i+=s:(r.set(p,s),i+=`<template ${fe}="${p}"></template>`)}}const f=document.createElement("template");f.innerHTML=i;const h=f.content;return h.querySelectorAll(`template[${fe}]`).forEach(p=>{const s=p.getAttribute(fe);if(s===null)return;const q=Number(s),x=r.get(q);x!==void 0&&p.replaceWith(x)}),h}var me="yqr-sticky-bar-drawer",Pe="yqr-sticky-bar-drawer--open",Ie="yqr-sticky-bar-drawer-styles";function qt(){if(document.getElementById(Ie)!==null)return;const e=document.createElement("style");e.id=Ie,e.textContent=Ct,document.head.appendChild(e)}function Et(e){const{container:t,formatPrice:r,config:i,onCheckout:a,onContinue:f,onChangeQuantity:h,onStateChange:p}=e;qt();let s=null,q=null,x=null,g=null,l=null,_=null,v=null,b=!1,E=0;const w=[];function L(){const u=O`
      <div
        id="${me}"
        class="yqr-sticky-bar-drawer"
        data-yqr-sticky-bar-drawer
        aria-hidden="true"
      >
        <button
          type="button"
          class="yqr-sticky-bar-drawer__peek"
          data-yqr-sticky-bar-drawer-peek
          aria-expanded="false"
          aria-controls="${me}"
        ><svg
            class="yqr-sticky-bar-drawer__peek-icon"
            viewBox="0 0 14 8"
            width="14"
            height="8"
            aria-hidden="true"
            focusable="false"
          ><path
              d="M1.5 6.5 L7 1.5 L12.5 6.5"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            /></svg
          ><span class="yqr-sticky-bar-drawer__peek-label">${i.viewRoutineLabel}</span></button>
        <div class="yqr-sticky-bar-drawer__panel">
          <div
            class="yqr-sticky-bar-drawer__list"
            data-yqr-sticky-bar-drawer-list
          ></div>
          <div class="yqr-sticky-bar-drawer__total-row">
            <span
              class="yqr-sticky-bar-drawer__count"
              data-yqr-sticky-bar-drawer-count
            ></span>
            <span
              class="yqr-sticky-bar-drawer__total"
              data-yqr-sticky-bar-drawer-total
            ></span>
            <span
              class="yqr-sticky-bar-drawer__savings"
              data-yqr-sticky-bar-drawer-savings
              aria-hidden="true"
            ></span>
          </div>
          <p class="yqr-sticky-bar-drawer__upsell" data-yqr-sticky-bar-drawer-upsell hidden></p>
          <button
            type="button"
            class="yqr-sticky-bar-drawer__cta yg-btn yg-btn--red"
            data-yqr-sticky-bar-drawer-checkout
          >${i.checkoutLabel}</button>
          <button
            type="button"
            class="yqr-sticky-bar-drawer__continue yg-mono-unit--muted"
            data-yqr-sticky-bar-drawer-continue
          >${i.continueLabel}</button>
        </div>
      </div>
    `;document.body.appendChild(u);const d=document.querySelector("[data-yqr-sticky-bar-drawer]");if(d===null)throw new Error("bar-drawer: failed to mount drawer element");return d}function I(u){if(q!==null){q.innerHTML="";for(const y of u){var d;const B=y.imageUrl!==null?O`<img
            class="yqr-sticky-bar-drawer__img"
            src="${y.imageUrl}"
            alt=""
            loading="lazy"
          />`:O`<span
            class="yqr-sticky-bar-drawer__img yqr-sticky-bar-drawer__img--placeholder"
            aria-hidden="true"
          ></span>`,S=[];y.variantTitle&&S.push(y.variantTitle),y.sellingPlanName!==null&&S.push(y.sellingPlanName);const D=S.length>0?O`<span class="yqr-sticky-bar-drawer__plan">${S.join(" · ")}</span>`:O``,M=y.originalLinePriceCents>y.priceCents,K=M?O`<span class="yqr-sticky-bar-drawer__price--original">${r(y.originalLinePriceCents)}</span>`:O``,U=M?"yqr-sticky-bar-drawer__price yqr-sticky-bar-drawer__price--discounted":"yqr-sticky-bar-drawer__price",F=O`
        <div class="yqr-sticky-bar-drawer__row" data-yqr-sticky-bar-drawer-row>
          ${B}
          <span class="yqr-sticky-bar-drawer__meta">
            <span class="yqr-sticky-bar-drawer__title">${y.productTitle.split(" - ")[0].trim()}</span>
            ${D}
            <span class="yqr-sticky-bar-drawer__prices">
              ${K}<span class="${U}">${r(y.priceCents)}</span>
            </span>
          </span>
          <span class="yqr-sticky-bar-drawer__qty-col">
            <span class="yqr-sticky-bar-drawer__stepper">
              <button type="button" class="yqr-sticky-bar-drawer__stepper-btn" data-yqr-qty-minus="${y.lineKey}" aria-label="Decrease">\u2212</button>
              <span class="yqr-sticky-bar-drawer__stepper-val" data-yqr-qty-val>${y.quantity}</span>
              <button type="button" class="yqr-sticky-bar-drawer__stepper-btn" data-yqr-qty-plus="${y.lineKey}" aria-label="Increase">+</button>
            </span>
            <button type="button" class="yqr-sticky-bar-drawer__remove-link" data-yqr-sticky-bar-drawer-remove="${y.lineKey}">${(d=i.removeLabel)!==null&&d!==void 0?d:"Remove"}</button>
          </span>
        </div>
      `;if(h!==void 0){const Q=F.querySelector(`[data-yqr-qty-minus="${y.lineKey}"]`),X=F.querySelector(`[data-yqr-qty-plus="${y.lineKey}"]`),z=F.querySelector(`[data-yqr-sticky-bar-drawer-remove="${y.lineKey}"]`),de=y.quantity;Q&&Q.addEventListener("click",()=>{h(y.lineKey,de-1)}),X&&X.addEventListener("click",()=>{h(y.lineKey,de+1)}),z&&z.addEventListener("click",()=>{h(y.lineKey,0)})}q.appendChild(F)}}}function A(u){if(s!==null){if(E=u.itemCount,I(u.items),x!==null){const d=u.itemCount===1?i.itemCountOneTemplate:i.itemCountTemplate;x.textContent=d.replace("{count}",String(u.itemCount))}if(g!==null&&(g.textContent=r(u.totalCents)),l!==null)if(u.totalSavingsCents>0){const d=u.totalSavingsCents-u.discountCodeTotalCents,y=u.discountCodeTotalCents;let B=`<span class="yqr-sticky-bar-drawer__savings-line">${i.youSaveTemplate.replaceAll("{{amount}}",r(u.totalSavingsCents))}</span>`;if(y>0&&d>0){const S=Math.round(d/(u.recurringTotalCents+d)*100);B+=`<span class="yqr-sticky-bar-drawer__savings-line yqr-sticky-bar-drawer__savings-line--muted">${i.thenRecurringTemplate.replaceAll("{{amount}}",r(u.recurringTotalCents)).replaceAll("{{percent}}",String(S))}</span>`}l.innerHTML=B,l.setAttribute("aria-hidden","false"),l.classList.add("yqr-sticky-bar-drawer__savings--visible")}else l.innerHTML="",l.setAttribute("aria-hidden","true"),l.classList.remove("yqr-sticky-bar-drawer__savings--visible");_!==null&&(u.itemCount===1&&i.bundleUpsellMessage.length>0?(_.textContent=i.bundleUpsellMessage,_.hidden=!1):_.hidden=!0)}}function P(){b||s===null||(b=!0,s.classList.add(Pe),s.setAttribute("aria-hidden","false"),v==null||v.setAttribute("aria-expanded","true"),be("youngle_quiz:sticky_bar_expand",{item_count:E}),p==null||p(!0))}function C(){!b||s===null||(b=!1,s.classList.remove(Pe),s.setAttribute("aria-hidden","true"),v==null||v.setAttribute("aria-expanded","false"),p==null||p(!1))}function H(){return b}function k(u){s!==null&&(s.classList.toggle("yqr-sticky-bar-drawer--hidden",u),u&&C())}function T(u){if(!b)return;const d=u.target;d instanceof Node&&(t.contains(d)||s!=null&&s.contains(d))||C()}function o(u){b&&u.key==="Escape"&&(u.preventDefault(),C())}s=L(),q=s.querySelector("[data-yqr-sticky-bar-drawer-list]"),x=s.querySelector("[data-yqr-sticky-bar-drawer-count]"),g=s.querySelector("[data-yqr-sticky-bar-drawer-total]"),l=s.querySelector("[data-yqr-sticky-bar-drawer-savings]"),_=s.querySelector("[data-yqr-sticky-bar-drawer-upsell]"),v=s.querySelector("[data-yqr-sticky-bar-drawer-peek]"),v!==null&&w.push(V(v,"click",u=>{u.stopPropagation(),b?C():P()}));const Y=s.querySelector("[data-yqr-sticky-bar-drawer-checkout]");Y!==null&&w.push(V(Y,"click",()=>{a()}));const N=s.querySelector("[data-yqr-sticky-bar-drawer-continue]");N!==null&&w.push(V(N,"click",()=>{C(),f()})),w.push(V(document,"click",T)),w.push(V(document,"keydown",o));function $(){for(const u of w)u();w.length=0,s!==null&&s.parentNode!==null&&s.parentNode.removeChild(s),s=null,q=null,x=null,g=null,l=null,_=null,v=null,b=!1}return{update:A,open:P,close:C,isOpen:H,setHidden:k,destroy:$}}var Ct=`
.yqr-sticky-bar-drawer {
  position: fixed;
  overflow: hidden;
  background: var(--pure-white, #F8F8F8);
  z-index: 10000;
  pointer-events: auto;
  transition: max-height 160ms cubic-bezier(.2, .7, .2, 1),
              bottom 160ms cubic-bezier(.2, .7, .2, 1),
              box-shadow 160ms cubic-bezier(.2, .7, .2, 1);
}

.yqr-sticky-bar-drawer--hidden {
  display: none !important;
}

@media (max-width: 599px) {
  .yqr-sticky-bar-drawer {
    left: 0;
    right: 0;
    bottom: 0;
    max-height: var(--yqr-peek-height, 36px);
    border-top: var(--hairline, 1px solid #DCDCE2);
  }
  .yqr-sticky-bar-drawer--open {
    max-height: 70vh;
    overflow-y: auto;
  }
}

@media (min-width: 600px) {
  .yqr-sticky-bar-drawer {
    left: 0;
    right: 0;
    bottom: var(--yqr-sticky-bar-offset, 56px);
    max-height: 0;
    border-top: 0;
  }
  .yqr-sticky-bar-drawer--open {
    bottom: 0;
    max-height: 70vh;
    overflow-y: auto;
    border-top: var(--hairline, 1px solid #DCDCE2);
    box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.06);
  }
}

.yqr-sticky-bar-drawer__peek {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  height: var(--yqr-peek-height, 36px);
  margin: 0;
  padding: 0 var(--space-16, 16px);
  background: transparent;
  color: var(--gray-50, #64647A);
  border: 0;
  font-family: var(--font-mono, ui-monospace, monospace);
  font-size: 10px;
  font-weight: 500;
  line-height: 1;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  white-space: nowrap;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.yqr-sticky-bar-drawer--open .yqr-sticky-bar-drawer__peek {
  border-bottom: var(--hairline, 1px solid #DCDCE2);
}

.yqr-sticky-bar-drawer__peek:focus-visible {
  outline: 2px solid var(--cold-black, #0A0A0A);
  outline-offset: -2px;
}

.yqr-sticky-bar-drawer__peek-icon {
  flex-shrink: 0;
  display: block;
  width: 10px;
  height: auto;
  transition: transform 160ms cubic-bezier(.2, .7, .2, 1);
}

.yqr-sticky-bar-drawer__peek[aria-expanded="true"] .yqr-sticky-bar-drawer__peek-icon {
  transform: rotate(180deg);
}

.yqr-sticky-bar-drawer__panel {
  display: flex;
  flex-direction: column;
  gap: var(--space-12, 12px);
  padding: var(--space-16, 16px) var(--space-24, 24px);
  max-width: var(--page-width, 1200px);
  margin: 0 auto;
}

@media (max-width: 599px) {
  .yqr-sticky-bar-drawer__panel {
    padding-bottom: calc(var(--space-16, 16px) + env(safe-area-inset-bottom));
  }

  .yqr-sticky-bar-drawer__total-row {
    flex-wrap: wrap;
  }
}

.yqr-sticky-bar-drawer__list {
  display: flex;
  flex-direction: column;
}

.yqr-sticky-bar-drawer__row {
  display: grid;
  grid-template-columns: 40px 1fr auto;
  align-items: start;
  gap: var(--space-12, 12px);
  padding: var(--space-8, 8px) 0;
  min-width: 0;
  border-bottom: var(--hairline, 1px solid #EEEEF1);
}

.yqr-sticky-bar-drawer__row:last-child {
  border-bottom: var(--hairline, 1px solid #DCDCE2);
  padding-bottom: var(--space-12, 12px);
}

.yqr-sticky-bar-drawer__img {
  width: 40px;
  height: 40px;
  object-fit: cover;
  display: block;
  background: var(--gray-05, #EEEEF1);
  border-radius: 4px;
}

.yqr-sticky-bar-drawer__img--placeholder {
  display: block;
}

.yqr-sticky-bar-drawer__meta {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.yqr-sticky-bar-drawer__title {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: var(--font-sans, sans-serif);
  font-size: 14px;
  font-weight: 500;
  color: var(--cold-black, #0A0A0A);
}

.yqr-sticky-bar-drawer__plan {
  font-size: 11px;
  color: var(--gray-50, #64647A);
  font-family: var(--font-mono, monospace);
  letter-spacing: 0.04em;
}

.yqr-sticky-bar-drawer__prices {
  display: flex;
  align-items: baseline;
  gap: 6px;
  margin-top: 2px;
}

.yqr-sticky-bar-drawer__price {
  white-space: nowrap;
  font-size: 13px;
  font-weight: 500;
  color: var(--cold-black, #0A0A0A);
}

.yqr-sticky-bar-drawer__price--discounted {
  color: var(--fire-red, #ff4b00);
}

.yqr-sticky-bar-drawer__price--original {
  text-decoration: line-through;
  font-size: 11px;
  white-space: nowrap;
  color: var(--gray-50, #64647A);
}

.yqr-sticky-bar-drawer__qty-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.yqr-sticky-bar-drawer__stepper {
  display: inline-flex;
  align-items: center;
  border: 1px solid var(--gray-20, #c8c8d0);
  border-radius: var(--radius-pill, 999px);
  overflow: hidden;
}

.yqr-sticky-bar-drawer__stepper-btn {
  width: 36px;
  height: 36px;
  border: 0;
  background: transparent;
  color: var(--cold-black, #0A0A0A);
  font-family: var(--font-mono, monospace);
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-tap-highlight-color: transparent;
  padding: 0;
}

.yqr-sticky-bar-drawer__stepper-btn:hover {
  background: var(--gray-05, #EEEEF1);
}

.yqr-sticky-bar-drawer__stepper-val {
  min-width: 28px;
  text-align: center;
  font-family: var(--font-mono, monospace);
  font-size: 14px;
  font-weight: 600;
  color: var(--cold-black, #0A0A0A);
  user-select: none;
}

.yqr-sticky-bar-drawer__remove-link {
  background: transparent;
  border: 0;
  padding: 0;
  font-family: var(--font-mono, monospace);
  font-size: 10px;
  color: var(--gray-50, #64647A);
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
  -webkit-tap-highlight-color: transparent;
}

.yqr-sticky-bar-drawer__remove-link:hover {
  color: var(--cold-black, #0A0A0A);
}

.yqr-sticky-bar-drawer__total-row {
  display: flex;
  align-items: baseline;
  justify-content: center;
  flex-wrap: wrap;
  padding-top: var(--space-4, 4px);
}

.yqr-sticky-bar-drawer__count {
  display: none;
}

.yqr-sticky-bar-drawer__total {
  font-family: var(--font-sans, sans-serif);
  font-size: 18px;
  font-weight: 600;
  color: var(--cold-black, #0A0A0A);
}

.yqr-sticky-bar-drawer__savings {
  display: none;
  text-align: center;
  font-family: var(--font-mono, monospace);
  font-size: 11px;
  color: var(--fire-red, #ff4b00);
  font-weight: 500;
  letter-spacing: 0.04em;
  flex-basis: 100%;
}

.yqr-sticky-bar-drawer__savings--visible {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.yqr-sticky-bar-drawer__savings-line {
  display: block;
}

.yqr-sticky-bar-drawer__savings-line--muted {
  color: var(--gray-50, #64647A);
  font-weight: 400;
}


@media (prefers-reduced-motion: reduce) {
  .yqr-sticky-bar-drawer,
  .yqr-sticky-bar-drawer__peek-icon,
  .yqr-sticky-bar-drawer__remove {
    transition: none;
  }
}

.yqr-sticky-bar-drawer__upsell {
  margin: 0;
  padding: var(--space-12, 12px) var(--space-16, 16px);
  font-family: var(--font-mono, monospace);
  font-size: 12px;
  letter-spacing: 0.02em;
  color: var(--cold-black, #0a0a0a);
  text-align: center;
  background: var(--gray-05, #EEEEF1);
  border-radius: var(--radius-sm, 4px);
}

.yqr-sticky-bar-drawer__cta {
  width: 100%;
  margin-top: var(--space-4, 4px);
}

.yqr-sticky-bar-drawer__continue {
  background: transparent;
  border: 0;
  padding: var(--space-4, 4px);
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  color: var(--gray-50, #64647A);
  font-family: var(--font-mono, monospace);
}

.yqr-sticky-bar-drawer__continue:hover,
.yqr-sticky-bar-drawer__continue:focus-visible {
  text-decoration: underline;
}

@media (prefers-reduced-motion: reduce) {
  .yqr-sticky-bar-drawer {
    transition: none !important;
  }
}
`,ce="yqr-sticky-bar--visible";function xt(){const e=window.cart;e!=null&&typeof e=="object"&&(e.isCartDrawerLoaded=!1)}function At(e){const{root:t,tracker:r,formatPrice:i,config:a,primaryAnchorId:f,primaryName:h,secondaryAnchorId:p,secondaryName:s,onCheckout:q,onContinue:x}=e;let g=null,l=!1,_=!1,v=null,b=!1,E="primary",w=!1,L=null,I=null;const A=[];let P=null,C=null,H=null,k=null,T=null,o=null;const Y=5;function N(){const n="yqr-sticky-bar-styles";if(document.getElementById(n)!==null)return;const c=document.createElement("style");c.id=n,c.textContent=`
.yqr-sticky-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9998;
  display: flex;
  flex-direction: column;
  background: var(--pure-white, #F8F8F8);
  border-top: var(--hairline, 1px solid #DCDCE2);
  transform: translateY(100%);
  opacity: 0;
  transition: transform 280ms cubic-bezier(.2, .7, .2, 1),
              opacity 280ms cubic-bezier(.2, .7, .2, 1),
              bottom 160ms cubic-bezier(.2, .7, .2, 1);
  pointer-events: none;
}

.yqr-sticky-bar--visible {
  transform: translateY(0);
  opacity: 1;
  pointer-events: auto;
}

.yqr-sticky-bar__inner {
  display: flex;
  align-items: center;
  max-width: var(--site-width, var(--page-width, 1200px));
  width: 100%;
  margin: 0 auto;
  padding: var(--space-12, 12px) var(--gutter-mobile, 24px);
  min-height: 56px;
  gap: var(--space-16, 16px);
  cursor: pointer;
}

.yqr-sticky-bar__heading {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: 0;
  margin: 0;
  padding: 0;
  color: var(--cold-black, #0A0A0A);
  white-space: nowrap;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.yqr-sticky-bar__heading:focus-visible {
  outline: 2px solid var(--cold-black, #0A0A0A);
  outline-offset: 4px;
  border-radius: 2px;
}

.yqr-sticky-bar__heading-icon {
  flex-shrink: 0;
  display: block;
  color: var(--gray-50, #64647A);
  transition: transform 160ms cubic-bezier(.2, .7, .2, 1);
}

.yqr-sticky-bar--drawer-open .yqr-sticky-bar__heading-icon {
  transform: rotate(180deg);
}

.yqr-sticky-bar__heading-label {
  display: inline-block;
}

.yqr-sticky-bar__thumbs {
  display: flex;
  align-items: center;
  gap: 6px;
  list-style: none;
  margin: 0;
  padding: 0;
  min-width: 0;
}

.yqr-sticky-bar__thumb {
  display: block;
  width: 32px;
  height: 32px;
  object-fit: cover;
  background: var(--gray-05, #EEEEF1);
  border-radius: 4px;
  flex-shrink: 0;
}

.yqr-sticky-bar__thumb--placeholder {
  display: block;
}

.yqr-sticky-bar__thumb--more {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  background: var(--gray-05, #EEEEF1);
  color: var(--gray-50, #64647A);
  font-family: var(--font-mono, monospace);
  font-size: 11px;
  font-weight: 500;
  border-radius: 4px;
}

.yqr-sticky-bar__count {
  white-space: nowrap;
}

.yqr-sticky-bar__total {
  white-space: nowrap;
}

.yqr-sticky-bar__cta {
  flex-shrink: 0;
}

.yqr-sticky-bar__overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0);
  pointer-events: none;
  transition: background 160ms cubic-bezier(.2, .7, .2, 1);
}

.yqr-sticky-bar__overlay--visible {
  background: rgba(0, 0, 0, 0.35);
  pointer-events: auto;
}

@media (max-width: 599px) {
  .yqr-sticky-bar--visible {
    bottom: var(--yqr-peek-height, 36px);
  }
  .yqr-sticky-bar--visible.yqr-sticky-bar--empty {
    bottom: 0;
  }
  .yqr-sticky-bar--visible:not(.yqr-sticky-bar--drawer-open) {
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.04), 0 -6px 24px rgba(0, 0, 0, 0.03);
  }
  .yqr-sticky-bar__heading,
  .yqr-sticky-bar__thumbs {
    display: none;
  }
  .yqr-sticky-bar--empty .yqr-sticky-bar__heading {
    display: inline-flex;
    min-width: 0;
    white-space: normal;
    font-size: 12px;
    line-height: 1.3;
  }
  .yqr-sticky-bar__inner {
    justify-content: space-between;
  }
  .yqr-sticky-bar__count {
    margin-right: auto;
  }
  .yqr-sticky-bar--drawer-open .yqr-sticky-bar__inner {
    display: none;
  }
}

@media (min-width: 600px) {
  .yqr-sticky-bar {
    bottom: 0;
  }
  .yqr-sticky-bar__inner {
    padding: var(--space-8, 8px) var(--gutter, 24px);
    min-height: 56px;
    gap: var(--space-16, 16px);
  }
  .yqr-sticky-bar__thumbs {
    margin-right: auto;
  }
  .yqr-sticky-bar--drawer-open .yqr-sticky-bar__inner {
    display: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .yqr-sticky-bar,
  .yqr-sticky-bar__overlay {
    transition: none;
  }
}
`,document.head.appendChild(c)}function $(){const n=O`
      <div class="yqr-sticky-bar__inner" data-yqr-sticky-bar-inner>
        <button
          type="button"
          class="yqr-sticky-bar__heading yg-eyebrow"
          data-yqr-sticky-bar-heading
          aria-controls="${me}"
          aria-expanded="false"
        ><svg
            class="yqr-sticky-bar__heading-icon"
            viewBox="0 0 14 8"
            width="12"
            height="7"
            aria-hidden="true"
            focusable="false"
          ><path
              d="M1.5 6.5 L7 1.5 L12.5 6.5"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            /></svg
          ><span class="yqr-sticky-bar__heading-label">${a.viewRoutineLabel}</span></button>
        <ul
          class="yqr-sticky-bar__thumbs"
          data-yqr-sticky-bar-thumbs
          aria-hidden="true"
        ></ul>
        <span class="yqr-sticky-bar__count yg-mono-unit--muted" data-yqr-sticky-bar-count></span>
        <span class="yqr-sticky-bar__total yg-display-num--sm" data-yqr-sticky-bar-total></span>
        <button
          type="button"
          class="yqr-sticky-bar__cta yg-btn yg-btn--red"
          data-yqr-sticky-bar-checkout
        >${f!==null?a.emptyCtaLabel:a.checkoutLabel}</button>
      </div>
    `;t.innerHTML="",t.appendChild(n),P=t.querySelector("[data-yqr-sticky-bar-count]"),C=t.querySelector("[data-yqr-sticky-bar-total]"),H=t.querySelector("[data-yqr-sticky-bar-inner]"),k=t.querySelector("[data-yqr-sticky-bar-thumbs]");const c=document.createElement("div");c.className="yqr-sticky-bar__overlay",c.setAttribute("aria-hidden","true"),document.body.appendChild(c),T=c}function u(){const n=r.getState();be("youngle_quiz:sticky_bar_checkout",{item_count:n.itemCount,total_cents:n.totalCents,has_subscription:n.hasSubscriptionItems}),o==null||o.close(),q()}function d(n){if(n===null)return;const c=document.getElementById(n);c!==null&&c.scrollIntoView({behavior:"smooth",block:"start"})}function y(){if(!v){u();return}switch(E){case"primary":d(f);break;case"secondary":d(p);break;case"top":window.scrollTo({top:0,behavior:"smooth"});break}}function B(){switch(E){case"primary":return h!==null?a.emptyHeadingPrimaryTemplate.replace("{name}",h):a.emptyHeadingLabel;case"secondary":return s!==null?a.emptyHeadingSecondaryTemplate.replace("{name}",s):a.emptyHeadingLabel;case"top":return a.emptyHeadingTopLabel}}function S(){return E==="top"?a.emptyCtaTopLabel:a.emptyCtaLabel}function D(n){if(v===n)return;v=n,t.classList.toggle("yqr-sticky-bar--empty",n);const c=t.querySelector("[data-yqr-sticky-bar-checkout]");c!==null&&(c.textContent=n?S():a.checkoutLabel);const m=t.querySelector("[data-yqr-sticky-bar-heading]");m!==null&&(n?(m.innerHTML=`<span class="yqr-sticky-bar__heading-label">${B()}</span>`,m.setAttribute("aria-disabled","true"),m.style.cursor="default"):(m.innerHTML=`<svg class="yqr-sticky-bar__heading-icon" viewBox="0 0 14 8" width="12" height="7" aria-hidden="true" focusable="false"><path d="M1.5 6.5 L7 1.5 L12.5 6.5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg><span class="yqr-sticky-bar__heading-label">${a.viewRoutineLabel}</span>`,m.removeAttribute("aria-disabled"),m.style.cursor=""))}function M(){const n=t.querySelector("[data-yqr-sticky-bar-checkout]");n!==null&&(n.textContent=S());const c=t.querySelector("[data-yqr-sticky-bar-heading]");c!==null&&(c.innerHTML=`<span class="yqr-sticky-bar__heading-label">${B()}</span>`)}function K(n){return n instanceof Element&&n.closest("[data-yqr-sticky-bar-checkout]")!==null}function U(){o!==null&&(o.isOpen()?o.close():o.open())}function F(n){K(n.target)||v||U()}function Q(){o==null||o.close()}function X(n){t.classList.toggle("yqr-sticky-bar--drawer-open",n),T==null||T.classList.toggle("yqr-sticky-bar__overlay--visible",n);const c=t.querySelector("[data-yqr-sticky-bar-heading]");c==null||c.setAttribute("aria-expanded",n?"true":"false")}function z(n){if(k===null)return;k.innerHTML="";const c=n.slice(0,Y);for(const R of c){const W=R.imageUrl!==null?O`<li><img
            class="yqr-sticky-bar__thumb"
            src="${R.imageUrl}"
            alt=""
            loading="lazy"
          /></li>`:O`<li><span
            class="yqr-sticky-bar__thumb yqr-sticky-bar__thumb--placeholder"
            aria-hidden="true"
          ></span></li>`;k.appendChild(W)}const m=n.length-Y;if(m>0){const R=O`<li><span class="yqr-sticky-bar__thumb yqr-sticky-bar__thumb--more">+${String(m)}</span></li>`;k.appendChild(R)}}function de(n){if(P!==null){const c=n.itemCount===1?a.itemCountOneTemplate:a.itemCountTemplate;P.textContent=`· ${c.replace("{count}",String(n.itemCount))}`}C!==null&&(C.textContent=i(n.totalCents)),z(n.items),o==null||o.update(n)}function De(){if(!l){if(l=!0,!_){_=!0;const n=r.getState();be("youngle_quiz:sticky_bar_view",{item_count:n.itemCount,total_cents:n.totalCents})}t.style.display="",t.classList.add(ce),o==null||o.setHidden(!1),requestAnimationFrame(()=>{const n=t.offsetHeight;ue(n>0?n:a.paddingBottomCompensation)})}}function ne(){P!==null&&(P.textContent=""),C!==null&&(C.textContent=""),k!==null&&(k.innerHTML=""),l||(l=!0,t.style.display="",t.classList.add(ce),requestAnimationFrame(()=>{const n=t.offsetHeight;ue(n>0?n:a.paddingBottomCompensation)}))}function te(){l&&(l=!1,o==null||o.close(),o==null||o.setHidden(!0),t.classList.remove(ce),ue(0))}function ue(n){if(n>0){const m=n+36;document.documentElement.style.setProperty("--yqr-sticky-bar-offset",`${n}px`),document.documentElement.style.setProperty("--yqr-peek-height","36px"),document.documentElement.style.paddingBottom=`${m}px`}else document.documentElement.style.removeProperty("--yqr-sticky-bar-offset"),document.documentElement.style.removeProperty("--yqr-peek-height"),document.documentElement.style.paddingBottom=""}function ge(n){n.itemCount>0?(L=null,D(!1),de(n),o==null||o.setHidden(!1),De()):f!==null?(D(!0),o==null||o.close(),o==null||o.setHidden(!0),b&&!w?(l&&te(),ne()):(l&&te(),L=()=>ne())):(L=null,te())}function Lt(){N(),$(),o=Et({container:t,formatPrice:i,config:a,onCheckout:u,onContinue:()=>{x()},onChangeQuantity:(m,R)=>{ze(m,R).then(()=>xt())},onStateChange:X}),o.setHidden(!0);const n=t.querySelector("[data-yqr-sticky-bar-checkout]");n!==null&&A.push(V(n,"click",y)),H!==null&&A.push(V(H,"click",F)),T!==null&&A.push(V(T,"click",Q));const c=()=>{o==null||o.open()};document.addEventListener("yqr:routine-drawer:open",c),A.push(()=>document.removeEventListener("yqr:routine-drawer:open",c)),It(),g=r.onChange(ge),St(),Pt(),ge(r.getState())}function St(){const n=document.querySelectorAll("[data-yqr-recommendation-overview]");if(n.length===0){b=!0;return}const c=new Set;I=new IntersectionObserver(m=>{for(const W of m){const ie=W.target;!W.isIntersecting&&W.boundingClientRect.bottom<0?c.add(ie):c.delete(ie)}const R=c.size===n.length;R&&!b?(b=!0,L!==null?(L(),L=null):ge(r.getState())):!R&&b&&(b=!1,l&&v&&te())},{threshold:0});for(const m of n)I.observe(m);A.push(()=>{I==null||I.disconnect(),I=null})}function Pt(){if(f===null)return;const n=document.getElementById(f),c=p!==null?document.getElementById(p):null;let m=!1,R=!1,W=!1,ie=!1;const ve=c!==null;function Me(){v&&(ve&&W?(E="top",w=!1,M(),!l&&b&&ne()):ve&&ie?(w=!0,l&&te()):m?(ve?E="secondary":E="top",w=!1,M(),!l&&b&&ne()):R?(w=!0,l&&te()):(E="primary",w=!1,M(),!l&&b&&ne()))}if(n!==null){const ae=new IntersectionObserver(he=>{for(const Z of he)R=Z.isIntersecting,m=!Z.isIntersecting&&Z.boundingClientRect.bottom<0;Me()},{threshold:0});ae.observe(n),A.push(()=>ae.disconnect())}if(c!==null){const ae=new IntersectionObserver(he=>{for(const Z of he)ie=Z.isIntersecting,W=!Z.isIntersecting&&Z.boundingClientRect.bottom<0;Me()},{threshold:0});ae.observe(c),A.push(()=>ae.disconnect())}}function It(){function n(m){r.getState().itemCount!==0&&(m.preventDefault(),m.stopPropagation(),o!==null&&(l||De(),o.open()))}const c=document.querySelectorAll("[data-cart-drawer-toggle]");for(const m of c)m.addEventListener("click",n,{capture:!0}),A.push(()=>m.removeEventListener("click",n,{capture:!0}))}function $t(){g==null||g(),g=null;for(const n of A)n();A.length=0,o==null||o.destroy(),o=null,P=null,C=null,H=null,k=null,T==null||T.remove(),T=null,ue(0),t.innerHTML="",t.style.display="none",t.classList.remove(ce),t.classList.remove("yqr-sticky-bar--drawer-open")}return{mount:Lt,destroy:$t}}var Tt="[data-yqr-sticky-bar]";function $e(){const e=Oe(Tt);if(e===null)return;let t;try{t=_t(e)}catch(r){if(r instanceof et){console.warn(`[YQR-sticky-bar] ${r.message}`);return}throw r}Fe({container:document.querySelector("[data-cart-drawer]")}),Ye(r=>{var i,a,f,h,p,s,q;const x=Qe(r.catalog);x.start();const g=[...(i=r.result.formulas)!==null&&i!==void 0?i:[],...(a=r.result.foundations)!==null&&a!==void 0?a:[],...(f=r.result.sports)!==null&&f!==void 0?f:[]],l=(h=g[0])!==null&&h!==void 0?h:null,_=(p=g[1])!==null&&p!==void 0?p:null,v=l!=null&&l.shopify_id?Le(l.shopify_id):null,b=(s=l==null?void 0:l.title)!==null&&s!==void 0?s:null,E=_!=null&&_.shopify_id?Le(_.shopify_id):null,w=(q=_==null?void 0:_.title)!==null&&q!==void 0?q:null;At({root:e,tracker:x,formatPrice:r.formatPrice,config:t,primaryAnchorId:v,primaryName:b,secondaryAnchorId:E,secondaryName:w,onCheckout:()=>{window.location.assign(Xe("checkout"))},onContinue:()=>{}}).mount(),document.addEventListener("youngle:add-to-cart-result",L=>{L.detail.ok&&Ce()})})}document.readyState==="loading"?document.addEventListener("DOMContentLoaded",$e):$e()})();
